var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanylog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_127_70909"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 46,
    height: 46,
    rx: 0
  })))), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39,
    cy: 39,
    rx: 39,
    ry: 39,
    fill: "#EAF2FF",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_127_70909)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.10000000149011612
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,57.818359375L60,57.818359375Q62,57.818359375,62,59.909269375Q62,62.000179375,60,62.000179375L18,62.000179375Q16,62.000179375,16,59.909269375Q16,57.818359375,18,57.818359375Z",
    fill: "#1269FF",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.39986373046875,21.93675L44.00512373046875,16.0359528C44.64352373046875,15.86172,45.272723730468755,16.342677,45.272723730468755,17.00486L45.272723730468755,58.8636L20.18182373046875,58.8636L20.18182373046875,24.842460000000003C20.18187579896875,23.48443,21.09029273046875,22.29436,22.39986373046875,21.93675Z",
    fill: "#1269FF",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.272705078125,33.7734375L56.888805078125,41.0969675C57.465805078125,41.4608875,57.818205078125004,42.1116075,57.818205078125004,42.8131875L57.818205078125004,58.864337500000005L45.272705078125,58.864337500000005L45.272705078125,33.7734375Z",
    fill: "#1269FF",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.38459880859375,30.63671875L37.06992880859375,30.63671875Q39.000028808593754,30.63671875,39.000028808593754,32.72762875Q39.000028808593754,34.81853875,37.06992880859375,34.81853875L28.38459880859375,34.81853875Q26.45452880859375,34.81853875,26.45452880859375,32.72762875Q26.45452880859375,30.63671875,28.38459880859375,30.63671875Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.38459880859375,39L37.06992880859375,39Q39.000028808593754,39,39.000028808593754,41.09091Q39.000028808593754,43.18182,37.06992880859375,43.18182L28.38459880859375,43.18182Q26.45452880859375,43.18182,26.45452880859375,41.09091Q26.45452880859375,39,28.38459880859375,39Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.38459880859375,46.318359375L37.06992880859375,46.318359375Q39.000028808593754,46.318359375,39.000028808593754,48.409269375Q39.000028808593754,50.500179375,37.06992880859375,50.500179375L28.38459880859375,50.500179375Q26.45452880859375,50.500179375,26.45452880859375,48.409269375Q26.45452880859375,46.318359375,28.38459880859375,46.318359375Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.19694880859375,46.318359375L52.93937880859375,46.318359375Q54.68179880859375,46.318359375,54.68179880859375,48.409269375Q54.68179880859375,50.500179375,52.93937880859375,50.500179375L51.19694880859375,50.500179375Q49.45452880859375,50.500179375,49.45452880859375,48.409269375Q49.45452880859375,46.318359375,51.19694880859375,46.318359375Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanylog);
export default __webpack_public_path__ + "static/media/companylog.88f8152c42de41b369529f6bdaffacb8.svg";
export { ForwardRef as ReactComponent };